import './index.css'
import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { isStagingDomain, isLocalDomain } from "../../helpers/domainChecker";

function Home() {
    const navigate = useNavigate();
    const [page,setPage]=useState('')
    function handleClick(page){
     return ()=>{
      setPage(page)
     }
    }
    useEffect(()=>{
      if (isLocalDomain() || isStagingDomain()) navigate(page);
      else navigate('/404');
    },[page,navigate])
    return (
      <Box className="test_page">
        <Button variant="contained" onClick={handleClick('/fsl2-plus')}>
          Go to default page
        </Button>
        <Button variant="contained" onClick={handleClick('/fsl2-plus/direct-patient-orders')}>
          Go to direct patient orders (FSL2+)
        </Button>
        <Button variant="contained" onClick={handleClick('/fsl2-plus/starter-clinic-orders')}>
          Go to starter clinic orders (FSL2+)
        </Button>
        <Button variant="contained" onClick={handleClick('/fsl2-plus/starter-letter-orders')}>
          Go to starter letter order (FSL2+)
        </Button>
         <Button variant="contained" onClick={handleClick('/fsl3-plus/direct-patient-orders')}>
          Go to direct patient orders (FSL3+)
        </Button>
        <Button variant="contained" onClick={handleClick('/fsl3-plus/starter-clinic-orders')}>
          Go to starter clinic orders (FSL3+)
        </Button>
        <Button variant="contained" onClick={handleClick('/thankyou')}>
          Go to thankyou (FSL2 / FSL2+)
        </Button>
        <Button variant="contained" onClick={handleClick('/fsl2-plus/thankyou')}>
          Go to thankyou (FSL2+)
        </Button>
        <Button variant="contained" onClick={handleClick('/fsl3-plus/thankyou')}>
          Go to thankyou (FSL3+)
        </Button>
        <Button variant="contained" onClick={handleClick('/insulet')}>
          Go to Insulet Page
        </Button>
        <Button variant="contained" onClick={handleClick('/hcp-primary-care')}>
          Go to hcp-primary-care Page
        </Button>
        <Button variant="contained" onClick={handleClick('/patient-primary-care')}>
          Go to Patient Primary Care Page
        </Button>
        <Button variant="contained" onClick={handleClick('/fsl2/direct-patient-orders')}>
          Go to B2C direct patient orders (FSL2)
        </Button>
        <Button variant="contained" onClick={handleClick('/fsl2/starter-clinic-orders')}>
          Go to starter B2C clinic orders (FSL2)
        </Button>
      </Box>
    );
}
  
export default Home;
